import React from "react";
import { CCard, CCardBody, CContainer } from "@coreui/react";

const Error = () => {
  const url = window.location.href;

  return (
    <>
      <header className="mainHeader">
        <div className="logo">
          <img src="/easypaper_BI.png" alt="logo" width="150px" />
        </div>
      </header>
      <CContainer fluid>
        <div className="c-main">
          <CCard className="errCard">
            <CCardBody>
              <h5>URL을 확인해주세요.</h5>
              <h6>현재 접속하신 URL은<br></br>
              <span><b>{url}</b></span><br></br>
              입니다.</h6>
            </CCardBody>
          </CCard>
        </div>
      </CContainer>
    </>
  );
};

export default Error;
